module.exports = __webpack_public_path__ + "img/noHistory@2x.a0c83651.png";